export default __webpack_public_path__ + "static/media/icon_8_on.d94e5859.png";